import angular from 'angular';
import usageDataComponent from './usage-data.component';

export default angular.module('components.app.product.usageDataForm', [])
  .component('usageData', usageDataComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/usage-data/usage-data.module.js